<div class="container">
    <div class="mt-2 flex grow" [ngStyle.xs]="{ 'min-width.%': 100 }" [ngStyle.sm]="{ 'width.%': 70 }">
        <mat-google-maps-autocomplete #autocomplete
            class="flex grow"
            type="address"
            [country]="countries"
            [strictBounds]="true"
            [address]="address?.formattedAddress || ''"
            [addressLabelText]="addressLabel ? addressLabel : 'Adresa'"
            invalidErrorText=""
            [placeholderText]="placeholderText"
            [appearance]="appearance.FILL"
            (onAutocompleteSelected)="onAutocompleteSelected($event)"
            (onLocationSelected)="onLocationSelected($event)"
            (onChange)="addressTouched()"
            (focusout)="lostFocus()"
        ></mat-google-maps-autocomplete>
        <button *ngIf="showMap" mat-icon-button type="button" color="primary" (click)="toggleMap()" class="mt-6">
            <i class="icon-size-8 fas fa-map-marker-alt"></i>
        </button>
    </div>

    <mat-error class="-mt-4" *ngIf="!address?.latitude && touched">{{ "section.geo.pick_valid_address" | translate }}</mat-error>

    <div class="map my-2" *ngIf="isMapOpen">
        <google-map #map height="300px" width="100%" [center]="{ lat: latitude, lng: longitude }" [zoom]="zoom" [options]="mapOptions" (mapInitialized)="mapReadyHandler($event)">
            <map-marker
                *ngIf="marker"
                [position]="{ lat: marker.lat, lng: marker.lng }"
                [options]="{ animation: google.maps.Animation.DROP, draggable: marker.draggable }"
                (mapClick)="clickedMarker()"
            ></map-marker>
        </google-map>

        <mat-checkbox class="-pt-4" name="customMarker" [(ngModel)]="customMarker" (ngModelChange)="customMarker = $event">
            <mat-label class="fuse-mat-no-subscript">{{ "section.geo.pick_own_address" | translate }}</mat-label>
        </mat-checkbox>
    </div>
</div>
